module.exports = __webpack_public_path__ + "img/step49_b_printer_basic_remove_tapes.96753cd7.png";